import React, { useState, useEffect } from "react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import { useDispatch, useSelector } from "react-redux";
import { patientActions } from "../../core/actions";
import { tokenActions } from "../../core/actions";
import Button from "@mui/material/Button";
import { Dialog, DialogActions, DialogTitle } from "@material-ui/core";
import { DialogContent } from "@mui/material";
import { useOrganization } from "../../configurations/OrganizationContext";
import Components from "..";
import { format } from "date-fns";
import {
  ERP_LOCATION_MAP_LOCATION_NAME,
  ERP_VISIT_FIN_SUMMARY_TYPE_NEW_INVOICE,
  ERP_GENERATE_INVOICE_REQUEST,
  ERP_OUT_PATIENT_BILLING_LOC_NAME,
  ERP_IN_PATIENT_BILLING_LOC_NAME,
  ERP_CURRENCY_OBJ,
  ERP_LABEL_MOVETOBILL,
  ERP_VISIT_FIN_SUMMARY_TYPE_SO,
  PATIENT_VISIT_TYPE,
} from "../../core/constants/erpConstants";
import {
  getAllSalesOrder,
  savePatientInvoice,
  getAllMasterLocationDetails,
} from "../erp-billing/ERPActions/erpActions";
import { set } from "lodash";
import { helperServices } from "../../shared/helper";

function LayoutHeader(props) {
  const org = useOrganization();
  const [patientTokenList, setPatientTokenList] = useState();
  const [markCompleteModal, setmarkCompleteModal] = useState(false);
  const [visitCompleteModal, setVisitCompleteModal] = useState(false);
  const [soIdnullModal, setSoIdnullModal] = useState(false);
  const [onModel, setOnModal] = useState(false);
  const [locationId, setLocationId] = useState();
  const [invDetails, setInvDetails] = useState();
  const currentUser= helperServices.getLoggedUserID();
  //Prathibha - erp clinic changes
  const [enableFollowUp, setEnableFollowUp] = useState(false);

  const [isClinicVersion, setIsClinicVersion] = useState(false);
  const [clinicMarkCompletionModal, setClinicMarkCompletionModal] =
    useState(false);
  //

  const floorsList = useSelector(
    (state) => state.patientDetailsState.floorsList
  );
    const masterLocationDetails = useSelector(
    (state) => state.erpDetailsState.masterLocationDetails
  );
  const dispatch = useDispatch();
  const tokenlist = useSelector((state) => state.patientDetailsState.tokenlist);
  const [rowData, setRowData] = useState([]);
  // console.log("token is",tokenlist);
  useEffect(async () => {
    console.log("props in layout header: ", props);

    if (process.env.REACT_APP_ENV === "clinic") {
      setIsClinicVersion(true);
    }
    if (
      !props.readOnly &&
      props?.selectedPatient &&
      Object.keys(props.selectedPatient).length > 0
    ) {
      fetchSalesOrder();
      let locId = 0;
      if ( props?.selectedPatient?.visit)
      {
        locId = await helperServices.getLocationIdByvisitType(
          masterLocationDetails,
          props?.selectedPatient?.visit?.type,
        );
      }
      setLocationId(locId);
    }
    console.log("props in layout header:", props);
    console.log("props in layout headers:", props.selectedPatient);
    console.log("floorsList", floorsList);
    console.log("tokenlist in layout header", tokenlist);
  }, [props?.selectedPatient, onModel]);

  const fetchSalesOrder = async (shouldShowAdd = true) => {
    console.log("selectedPatient", props.selectedPatient);

    let patientId = props?.selectedPatient?.id;
    let visitId = props?.selectedPatient?.visit?.id;
    try {
      console.log(
        `patientId : ${patientId} :: visitId : ${visitId} ::  locationId : ${locationId}`
      );

      let locDetail = locationId;
      let loc = [];
      if (
        locDetail &&
        locDetail.locationDetails &&
        locDetail.locationKey !== "all"
      ) {
        loc = locDetail.locationDetails.erpLocationDetails[0].locationid;
      }
      console.log(
        `patientId : ${patientId} :: visitId : ${visitId} ::  locationId : ${loc}`
      );

      const response = await getAllSalesOrder(patientId, visitId, loc);
      if (response) {
        console.log("getAllSalesOrder : response : ", response);
        getAllRowData(response.serviceList);
      }
    } catch (error) {
      console.error("Error fetching sales order:", error);
    }
  };

  function getAllRowData(serviceList) {
    let uRowData = [];
    console.log("get all row i/p data : ", serviceList);

    if (serviceList != null) {
      serviceList.forEach((service) => {
        // soData.salesOrderLineItems.forEach((soLineOrderItems) => {
        // let amount = soLineOrderItems.price * soLineOrderItems.units;
        let row = {
          soId: service.soId,
          serviceName: service.productName,
          prodId: service.prodId,
          productName: service.productName,
          description: service.description,
          quantity: service.quantity,
          amount: `₹ ${service.amount}`,
          price: service.amount,
          location: ERP_LOCATION_MAP_LOCATION_NAME[service.locationId],
          locationId: service.locationId,
          voucherList: "",
          doctor: "",
          action: "",
          soLinID: service.salesLineId,
        };
        uRowData.push(row);
        // });
        console.log("salesOrder : ", service);
      });
    }
    // return uRowData;
    console.log("salesOrder : ", uRowData);
    setRowData(uRowData);
  }

  const closeModal = () => {
    props.onModalClose();
  };
  const allPatientsList = useSelector(
    (state) => state.patientDetailsState.patientsList
  );
  const handleFloorChange = (id) => {
    let data = {};
    console.log("id : ", id);
    data["floorId"] = id;
    data["type"] = "mypatient";
    dispatch(
      patientActions.ListPatients(data, (resCb) => {
        if (resCb) {
          console.log("response is: ", resCb);
          console.log("Diagnosis Master API Response:", allPatientsList);
        }
      })
    );
  };

  const handlemarkCompleteModal = (event) => {
    setmarkCompleteModal(true);
  };

  const moveToBilling = (event) => {
    // if (org?.id == "2") {
      setOnModal(true);
    // } else {
    //   setVisitCompleteModal(true);
    // }
  };

  const closeProcess = (event) => {
    setSoIdnullModal(true);
  };
  const soIdCheck = (event) => {
    props.onPatientBasic();
    moveToBilling();
    // let data = {};
    // data["patientId"] = props.selectedPatient.visit.patientId;
    // data["visitId"] = props.selectedPatient.visit.id;
    // dispatch(
    //   patientActions.soIdCheck(data, (resCb) => {
    //     if (resCb) {
    //       console.log("soIdCheckresponse response", resCb);
    //       if (resCb.keyword && resCb.keyword == "soIdpresent") {
    //         console.log("keyword is", resCb.keyword);
    //       } else if (resCb.keyword && resCb.keyword == "clinicFormat") {
    //         console.log("keyword is", resCb.keyword);
    //         moveToBilling();
    //       } else {
    //         console.log("keyword is", resCb.keyword);
    //         closeProcess();
    //       }
    //     }
    //   })
    // );
  };

  const handleopenDeleteModal = () => {
    props.onPatientBasic();
    setmarkCompleteModal(!markCompleteModal);
  };

  const handleClinicDeleteModal = () => {
    props.onPatientBasic();
    setClinicMarkCompletionModal(!clinicMarkCompletionModal);
  };

  const closeVisitCompleteModal = () => {
    props.onPatientBasic();
    console.log("Button clicked");
    setOnModal(false);
    setVisitCompleteModal(false);
  };

  const closesoIdnullModal = () => {
    props.onPatientBasic();
    console.log("Button clicked");
    setSoIdnullModal(!soIdnullModal);
  };
  const tokenComplete = () => {
    //  var ServerResVal = ServerRes;
    props.onPatientBasic();
    console.log("button clicked");
    console.log("props in layout header:", props);
    let visitId = props.selectedPatient.visit.id;
    var patientId = props.selectedPatient.visit.patientId;
    console.log("visit id:", visitId);
    dispatch(
      tokenActions.completeToken(patientId, visitId, (resCb) => {
        if (resCb) {
          console.log("tokenresponse response", resCb);
          if (resCb.successMessages) {
            console.log("tokenresponse response", resCb.successMessages);
            dispatch(patientActions.tokenList(resCb.patientresp));
            console.log("tokenlist in layout header", tokenlist);
            handleopenDeleteModal();
          } else {
            handleopenDeleteModal();
          }
        }
      })
    );
  };

  const visitComplete = () => {
    // props.onPatientBasic();
    let data = {};
    data["patientId"] = props.selectedPatient.visit.patientId;
    data["visitId"] = props.selectedPatient.visit.id;
    data["dischargeDate"] = "";
    dispatch(
      patientActions.moveToBilling(data, (resCb) => {
        if (resCb) {
          console.log("tokenresponse response", resCb);
          if (resCb.successMessages) {
            console.log("tokenresponse response", resCb.successMessages);
            if (isClinicVersion === true) {
              setIsClinicVersion(true);
              console.log("clinic version");
            }

            closeVisitCompleteModal();
            if (isClinicVersion === true) {
              props.onVisitCompletion("CLINIC");
            }
            props.onPatientBasic();
            dispatch(patientActions.tokenList(props.onPatientBasic()));
          } else {
            closeVisitCompleteModal();
            props.onPatientBasic();
          }
        }
      })
    );
  };

  const Billclearstatus = () => {
    // props.onPatientBasic();
    let data = {};
    data["patientId"] = props.selectedPatient.visit.patientId;
    data["visitId"] = props.selectedPatient.visit.id;
    dispatch(
      patientActions.billclearstatus(data, (resCb) => {
        if (resCb) {
          closesoIdnullModal();
        }
      })
    );
  };

  const handleGenerateInvoice = async (event) => {
    setOnModal(false);
    if (event && event !== undefined && event !== null) {
      console.log("Delete clicked for row: ", props.data, event, rowData);
      const SoList = {
        ...rowData,
        dataType: ERP_LABEL_MOVETOBILL,
        type: ERP_VISIT_FIN_SUMMARY_TYPE_SO,
      };
      console.log("data productSelected: ", SoList);
      //below line is to update the solist in the new invoice tab
      // setProductSelected(SoList);
      let rowList = [];
      Object.keys(rowData).forEach((key) => {
        if (!isNaN(key)) {
          const lineItem = rowData[key];
          const cleanedAmount =
            parseFloat(
              (lineItem.amount || "").toString().replace(/[₹,\s]/g, "")
            ) || 0;

          // Clone lineItem and clean amount in productDetail
          const cleanedProductDetail = {
            ...lineItem,
            amount: cleanedAmount,
            price: cleanedAmount,
          };

          const newRow = {
            date: "",
            slNo: lineItem.soLinID,
            soLineId: lineItem.soLinID,
            soId: lineItem.soId,
            serviceName: lineItem.productName,
            charges: cleanedAmount,
            quantity: lineItem.quantity,
            price: cleanedAmount,
            type: ERP_VISIT_FIN_SUMMARY_TYPE_NEW_INVOICE,
            productDetail: cleanedProductDetail, // 👈 Cleaned here!
            prodId: lineItem.prodId,
            action: "delete"
          };

          rowList.push(newRow);
        }
      });
      generateInvoice(rowList, ERP_LABEL_MOVETOBILL);
    }
  };

  const generateInvoice = async (rowList, label) => {
    if (rowList?.length > 0) {
      const invDetail = await convertMoveSoToInvDetails(rowList);
      console.log("generateInvoice: inv detail :: ", invDetail);

      if (invDetail) {
        const invResp = await savePatientInvoice(
          invDetail.loc,
          invDetail.invoiceDetail
        );

        if (invResp) {
          if (ERP_LABEL_MOVETOBILL === label) {
            const data = {
              patientId: props?.selectedPatient?.visit?.patientId,
              visitId: props?.selectedPatient?.visit?.id,
            };

            let dischargeDateTime = "";

            if (props?.selectedPatient?.visit?.type === "InPatient") {
              dischargeDateTime =
                props?.selectedPatient?.visit?.dischargeDate ||
                format(new Date(), "yyyy-MM-dd'T'HH:mm:ss");
            }

            data["dischargeDate"] = dischargeDateTime;
            data["checkType"] = "";

            dispatch(
              patientActions.erpV2moveToBill(data, (resCb) => {
                if (resCb.successMessages) {
                  console.log("invResp : ", invResp);
                  closeNewInvoice();
                }
              })
            );
          }
        }
      } else {
        closeNewInvoice();
      }
    }
  };

  const closeNewInvoice = () => {
    setRowData([]); // fixed spread operator misuse

    if (isClinicVersion === true) {
      setIsClinicVersion(true);
      console.log("clinic version");

      setOnModal(false);
      props.onVisitCompletion("CLINIC");
      props.onPatientBasic();
      dispatch(patientActions.tokenList(props.onPatientBasic()));
    } else {
      setOnModal(false);
      props.onPatientBasic();
    }
  };

  const convertMoveSoToInvDetails = (rowData) => {
    const currentDate = new Date();
    console.log("current Date: ", currentDate);

    let invoiceDetail = ERP_GENERATE_INVOICE_REQUEST;
    let loc = "";
    if (rowData && rowData.length > 0) {
      invoiceDetail.billNumber = null;
      invoiceDetail.date = `${currentDate.getFullYear()}-${currentDate.getMonth()}-${currentDate.getDate()}`;
      invoiceDetail.refund = false;
      invoiceDetail.m_sUser = "Support";
      invoiceDetail.patientId = props?.selectedPatient?.id;
      invoiceDetail.visitId = props?.selectedPatient?.visit?.id;
      invoiceDetail.invoiceLineItem = rowData;
      invoiceDetail.date = currentDate;
      invoiceDetail.erpCustId = props?.selectedPatient?.erpCustId;
      invoiceDetail.gvName =  currentUser;
      invoiceDetail.invoicePayments = "";
      let patientFullName = "";
      if (
        props?.selectedPatient?.fname &&
        props?.selectedPatient?.mname &&
        props?.selectedPatient?.lname
      ) {
        patientFullName =
          props?.selectedPatient?.fname +
          " " +
          props?.selectedPatient?.mname +
          " " +
          props?.selectedPatient?.lname;
      } else {
        patientFullName =
          props?.selectedPatient?.fname + " " + props?.selectedPatient?.lname;
      }
      invoiceDetail.m_sCustomerName = patientFullName;
      invoiceDetail.customerId = props?.selectedPatient?.erpCustId;
      invoiceDetail.billType = "SL";
      // if (
      //   ERP_PATIENT_VISIT_TYPE_OUT_PATIENT.toLowerCase() ===
      //   props?.selectedPatient?.visit.type.toLowerCase()
      // ) {
      //   loc =
      //     ERP_LOCATION_NAME_TO_LOCATION_ID_MAP[
      //       ERP_PATIENT_VISIT_TYPE_OUT_PATIENT
      //     ];
      // } else {
      //   loc =
      //     ERP_LOCATION_NAME_TO_LOCATION_ID_MAP[
      //       ERP_PATIENT_VISIT_TYPE_IN_PATIENT
      //     ];
      // }
      loc = locationId;
      invoiceDetail.location = loc;
      invoiceDetail.salesperson = "Support";
      invoiceDetail.narration = "";
      invoiceDetail.custome1 = "";
      invoiceDetail.custome2 = "";
      invoiceDetail.custome3 = "";
      invoiceDetail.discountRs = 0.0;
      invoiceDetail.discountPerc = 0.0;
      invoiceDetail.custome4 = "Custom field 4";
      invoiceDetail.roundOffQaulifier = "ROUND_OFF";
      invoiceDetail.narration1 = "";
      invoiceDetail.mrpInvoice = false;
      invoiceDetail.shippedAddress = "";
      invoiceDetail.currencyId = ERP_CURRENCY_OBJ.id;
      invoiceDetail.m_aLines = [];
      invoiceDetail.invoicePayments = [];
      invoiceDetail.m_dDate = currentDate; //`${currentDate.getDate()}-${currentDate.getMonth()}-${currentDate.getFullYear()}`,

      let invoiceTotalAmount = 0.0;
      let invLineItemList = [];
      // ERP_VISIT_FIN_SUMMARY_TYPE_NEW_INVOICE
      rowData.forEach((row) => {
        let invItem = {
          m_iTicketLine: row.slNo,
          m_sProdRef: row.prodId,
          m_sProdName: row.serviceName,
          m_dMultiply: row.quantity,
          m_dPrice: row?.productDetail?.sellprice,
          salesOrderId: row.soId,
          m_TaxInfo: {
            m_iID: row?.productDetail?.taxid,
            m_dRate: row?.productDetail?.taxRate,
          },
          m_dPriceBuy: row?.productDetail?.buyPrice,
          sellPriceIncTax: row?.productDetail?.sellPricetax,
          uomId: row?.productDetail?.uomid ? row.productDetail.uomid : null,
          m_discount_line: 0.0,
          varientId: row?.productDetail?.varientId,
          batchNo: row?.productDetail?.batchNo,
          type1: row?.productDetail?.type1,
          type2: row?.productDetail?.type2,
          type3: row?.productDetail?.type3,
          type4: row?.productDetail?.type4,
          sizeId: row?.productDetail?.sizeId,
          mrp: row?.productDetail?.sellPricetax,
          m_doriginalPriceSell: row?.productDetail?.sellprice,
          trackInventory: row?.productDetail?.trackinventory,
        };
        if (ERP_VISIT_FIN_SUMMARY_TYPE_SO === row.type) {
          invoiceTotalAmount += row.quantity * row.charges;
        } else if (ERP_VISIT_FIN_SUMMARY_TYPE_NEW_INVOICE === row.type) {
          invoiceTotalAmount += row.quantity * row.price;
        }
        invLineItemList.push(invItem);
      });
      let invPaymentDetail = [];
      invoiceDetail.invoiceTotalAmount = invoiceTotalAmount;
      invoiceDetail.m_aLines = invLineItemList;
      invoiceDetail.invoicePayments = invPaymentDetail;
      invoiceDetail.totalInvoiceAmount = invoiceTotalAmount;
    }

    // if (
    //   ERP_PATIENT_VISIT_TYPE_OUT_PATIENT.toLowerCase() ===
    //   props?.selectedPatient?.visit.type.toLowerCase()
    // ) {
    //   loc =
    //     ERP_LOCATION_NAME_TO_LOCATION_ID_MAP[
    //       ERP_PATIENT_VISIT_TYPE_OUT_PATIENT
    //     ];
    // } else {
    //   loc =
    //     ERP_LOCATION_NAME_TO_LOCATION_ID_MAP[ERP_PATIENT_VISIT_TYPE_IN_PATIENT];
    // }
    loc = loc;
    const invPopulateObj = {
      loc: loc,
      invoiceDetail: invoiceDetail,
    };
    setInvDetails(invPopulateObj);
    return invPopulateObj;
  };

  return (
    <>
      <div className="pres-header">
        {/*   <Col md="3"></Col> */}
        <div
          className={
            props.basic ? "pres-layout-basic-info" : "list-layout-header"
          }
        >
          <div className="main-content-container container-fluid p-0">
            <div className="mb-12 col-md-12 hpcol bg menu-head">
              <div className="blog-comments__item d-flex cpointer  p-2 menu-content">
                <div className="" onClick={(event) => props.onPatientBasic()}>
                  <div className="blog-comments__content layout-head-content">
                    <div className="blog-comments__meta text-mutes d-flex img-name justify-content-between">
                      <div className="d-flex align-items-center">
                        <div className="patient-img">
                          {props?.selectedPatient?.imgurl ? (
                            <img
                              className="w-100 h-100 img-disp"
                              src={props.selectedPatient.imgurl}
                            ></img>
                          ) : (
                            ""
                          )}
                        </div>
                        <div
                          className="text-secondary pname px-2"
                          style={{
                            textTransform: "capitalize",
                            margin: "right",
                          }}
                        >
                          {props?.selectedPatient?.fname}
                          <small>
                            {props.selectedPatient &&
                            props.selectedPatient.id != undefined
                              ? "(" + props.selectedPatient.id + ")"
                              : ""}
                          </small>
                        </div>

                        {/* {props && (props.lab_admin === true) !== (props.radiology === true) ? (
                          ""
                        ) : (
                          <>
                            {tokenlist &&
                            tokenlist.tokenNumber &&
                            tokenlist.visit &&
                            tokenlist.visit.type == "OutPatient" ? (
                              <div
                                className="text-secondary pname px-2"
                                style={{ margin: "left" }}
                              >
                                <button
                                  id="we"
                                  class="btn btn-primary"
                                  onClick={handlemarkCompleteModal}
                                  type="button"
                                >
                                  {" "}
                                  Mark completion
                                </button>
                              </div>
                            ) : (
                              ""
                            )} */}
                        {props &&
                        !props.readOnly &&
                        props.lab_admin !== true &&
                        props.radiology !== true &&
                        props.x_ray !== true &&
                        props?.medicalofficer !== true ? (
                          <>
                            {tokenlist &&
                            tokenlist.tokenNumber &&
                            tokenlist.visit &&
                            tokenlist.visit.type == "OutPatient" ? (
                              <div
                                className="text-secondary pname px-2"
                                style={{ margin: "left" }}
                              >
                                <button
                                  id="we"
                                  class="btn btn-primary"
                                  onClick={handlemarkCompleteModal}
                                  type="button"
                                >
                                  {" "}
                                  Mark completion
                                </button>
                              </div>
                            ) : (
                              ""
                            )}
                            {tokenlist &&
                            tokenlist.visit &&
                            tokenlist.visit.internalStatus &&
                            tokenlist.visit.internalStatus == "booked" &&
                            tokenlist.visit.type == "OutPatient" &&
                            org?.isVisitCompletion?.display ? (
                              <div
                                className="text-secondary pname px-2"
                                style={{ margin: "left" }}
                              >
                                <button
                                  id="we"
                                  class="btn btn-primary ml-2"
                                  onClick={soIdCheck}
                                  type="button"
                                >
                                  {" "}
                                  Visit Completion
                                </button>
                              </div>
                            ) : (
                              ""
                            )}
                          </>
                        ) : (
                          ""
                        )}
                      </div>

                      <div className="d-flex flex-column">
                        <small
                          className="text-muted"
                          style={{
                            fontSize: "12px",
                            fontWeight: 300,
                            display: "flex",
                            gap: "8px",
                            flexWrap: "wrap",
                            alignItems: "center",
                          }}
                        >
                          {Array.isArray(props?.selectedPatient?.roomList) &&
                            props.selectedPatient.roomList.some(
                              (room) => room.roomName
                            ) && (
                              <>
                                <i
                                  className="material-icons p-icon"
                                  style={{ fontSize: "16px" }}
                                >
                                  bed
                                </i>
                                {props.selectedPatient.roomList.map(
                                  (room, index, arr) => (
                                    <span key={room.id}>
                                      {room.roomName}
                                      {index < arr.length - 1 && ","}
                                    </span>
                                  )
                                )}
                              </>
                            )}
                        </small>
                        <small
                          className="text-muted"
                          style={{
                            fontSize: "12px",
                            fontWeight: 300,
                            display: "flex",
                            gap: "8px",
                            flexWrap: "wrap",
                            alignItems: "center",
                          }}
                        >
                          {props.selectedPatient?.phno && (
                            <>
                              <i
                                className="material-icons p-icon"
                                style={{ fontSize: "16px" }}
                              >
                                phone
                              </i>
                              <span>{props.selectedPatient.phno}</span>
                            </>
                          )}
                        </small>
                      </div>
                    </div>
                  </div>
                  {/* <div className="blog-comments__content menu-head-icon">
                                  <div className="blog-comments__meta text-mutes">
                                      <div className="text-secondary pname">
                                      {floorsList && floorsList.length > 0 ?
                                        <FormSelect onChange={event => { handleFloorChange(event.target.key) }}>
                                            {floorsList && floorsList.map((floor,index)=>(
                                                <option value={floor.name} key={index} id={floor.id}>{floor.name}</option>
                                            ))}
                                        </FormSelect>
                                        :''}
                                      </div>
                                  </div>
                                </div>  */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Dialog
        className="Mark_Completion"
        open={markCompleteModal}
        toggle={handlemarkCompleteModal}
      >
        <DialogTitle>Mark Completion</DialogTitle>
        <DialogContent>
          {isClinicVersion === true
            ? "Do you want to mark completion ?"
            : "Do you want to complete the token ?"}
        </DialogContent>
        <DialogActions style={{ justifyContent: `space-between` }}>
          <Button
            variant="contained"
            color="primary"
            sx={{ textTransform: "none" }}
            onClick={handleopenDeleteModal}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={{ textTransform: "none" }}
            onClick={tokenComplete}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        className="Visit_Completion"
        open={visitCompleteModal}
        toggle={closeVisitCompleteModal}
      >
        <DialogTitle>Visit Completion</DialogTitle>
        <DialogContent>Do you want to complete the consultation</DialogContent>
        <DialogActions style={{ justifyContent: `space-between` }}>
          <Button
            variant="contained"
            color="primary"
            sx={{ textTransform: "none" }}
            onClick={closeVisitCompleteModal}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={{ textTransform: "none" }}
            onClick={visitComplete}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        className="soIdnullModal_Visit_Completion1"
        open={soIdnullModal}
        toggle={closesoIdnullModal}
      >
        <DialogTitle>Visit Completion</DialogTitle>
        <DialogContent>
          No service has been added to this user which means he has no payment
          to be made. Do you want to continue?
        </DialogContent>
        <DialogActions style={{ justifyContent: `space-between` }}>
          <Button
            variant="contained"
            color="primary"
            sx={{ textTransform: "none" }}
            onClick={closesoIdnullModal}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={{ textTransform: "none" }}
            onClick={Billclearstatus}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      {onModel ? (
        <Components.MoveToBilling
          visitList={props.selectedPatient}
          open={onModel}
          onModalClose={(e) => handleGenerateInvoice(e)}
          handleModelclose={(e) => closeVisitCompleteModal()}
          // pass directly
        />
      ) : (
        ""
      )}
    </>
  );
}

export default LayoutHeader;
